import { Injectable } from "@angular/core";
import { Response } from "@angular/http";
import { Observable } from "rxjs/Observable";

import { CrudService } from "@atenea-cms";
import { Download } from "./download.model";

@Injectable()
export class DownloadService extends CrudService {
  getRootUrl(): string {
    return "downloads";
  }

  save(download: Download) {
    return super.save(download);
  }

  saveMultiple(downloads: Array<Download>) {
    return super.saveMultiple(downloads);
  }
}



// WEBPACK FOOTER //
// ./libs/atenea-cms-brand/src/downloads/shared/download.service.ts